const PbxxRecord = require('../pbxx_record')

module.exports = class EmbedShare extends PbxxRecord {
  static get class_name() {
    return 'EmbedShare'
  }
}
